// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__hC7H3","tooltiptext":"styles_tooltiptext__ZiMAh"};